import { PropsWithChildren, useMemo } from 'react';
import { Line, LineChart } from 'recharts';

import { BaseChart } from '../../BaseChart/BaseChart';
import { CubeChartBaseProps } from '../CubeChart.types';

const ACTIVE_DOT: any = { r: 6, strokeWidth: 4 };

export const CubeChartLine = <TData extends Record<string, any>>({
  resultSet,
  formatter,
}: PropsWithChildren<CubeChartBaseProps<TData>>) => {
  const dataConfig = useMemo(() => (formatter?.x ? { formatter: formatter.x } : undefined), [formatter?.x]);
  const yAxis = useMemo(() => (formatter?.y ? { tickFormatter: formatter.y } : undefined), [formatter?.y]);
  return (
    <BaseChart
      data={resultSet.chartPivot()}
      dataKey="x"
      chartComponent={LineChart}
      dataConfig={dataConfig}
      yAxis={yAxis}
      legend
      tooltip
    >
      {({ colors }) => (
        <>
          {resultSet.seriesNames().map((series, i) => (
            <Line
              key={series.key}
              dataKey={series.key}
              name={series.title}
              type="linear"
              dot={false}
              activeDot={ACTIVE_DOT}
              strokeWidth={3}
              stroke={colors[i]}
              isAnimationActive={false}
              legendType="circle"
            />
          ))}
        </>
      )}
    </BaseChart>
  );
};
